import {
  Autocomplete,
  Box, Input,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow, TextField,
  Typography
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {grey} from "@mui/material/colors";
import {ConversationTableRow} from "./ConversationTableRow";
import DatePicker from "react-datepicker";
import moment from "moment";
import {useAtom} from "jotai";
import {SelectedConversationAtom} from "../atoms";
import {useDashboard} from "../../../../context/DashboardContext";


export const ConversationsTable = ({project}) => {
  const {conversations, pagination, setPagination, refreshConversations, updatedValue} = useDashboard();
  const [selectedConversation, setSelectedConversation] = useAtom(SelectedConversationAtom);
  const [filters, setFilters] = useState({
    id: "",
    start: null,
    end: null,
    caller: "",
    status: null,
    vdn: "",
  })

  useEffect(() => {
    if (conversations && conversations?.length) {
      const conversation = conversations?.find(i => i?.id === selectedConversation?.id);
      if (conversation) {
        setSelectedConversation(conversation);
      }
    }
  }, [conversations, selectedConversation?.id])

  useEffect(() => {
    if (project?.id) {
      const getDate = date => {
        return date.getTime();
      }

      const formattedFilters = {
        ...filters,
        start: filters?.start ? getDate(filters?.start) : undefined,
        end: filters?.end ? getDate(filters?.end) : undefined,
      };

      refreshConversations(formattedFilters);

      const interval = setInterval(() => {
        refreshConversations(formattedFilters);
      }, 60 * 1000);

      return () => clearInterval(interval);
    }
  }, [project?.id, pagination?.page, pagination?.size, filters, updatedValue, refreshConversations])

  const scrollConversations = (elementId = "conversation-tbody") => {
    const tbody = document?.getElementById(elementId);
    if (tbody) {
      tbody?.scrollIntoView({behavior: "smooth", block: "end"})
    } else {
      throw new Error("Element not found")
    }
  }

  const type = project?.settings?.projectType || "VOICE_BOT"

  return (
    <Stack direction="column" gap={0} sx={{borderRadius: 3}}
           className={"border-shadow"}>
      <Box sx={{px: 2, pt: 2}}>
        <Typography variant={"body1"} color={grey[500]}>CONVERSATION LOGGER</Typography>
      </Box>
      <TableContainer sx={{maxHeight: "57dvh", minHeight: "50dvh"}}>
        <Table stickyHeader aria-label="sticky table" sx={{height: "100%", p: 2, pt: 1}}>
          <TableHead>

            <TableRow>
              <TableCell padding={"checkbox"} sx={{py: 1, px: 1}}>
                <Input
                  className={"table-input"}
                  value={filters?.id} placeholder={"ID"}
                  onChange={e => setFilters(prev => ({...prev, id: e?.target?.value}))}
                />
              </TableCell>
              <TableCell padding={"checkbox"} sx={{py: 1, px: 1, display: {xs: "none", md: "table-cell"} }}>
                <Stack direction={"row"} gap={1}>
                  <DatePicker
                    placeholderText={"Start Date"}
                    dateFormat={"dd MMM YYYY"}
                    selected={filters?.start}
                    maxDate={filters?.end || new Date()}
                    onChange={(newValue) => {
                      if (newValue) {
                        // Set time to 00:00:00
                        const startOfDay = moment(newValue).set({ hour: 0, minute: 0, second: 0 }).toDate();
                        setFilters((prev) => ({ ...prev, start: startOfDay }));
                      } else {
                        setFilters((prev) => ({ ...prev, start: null }));
                      }
                    }}
                  />
                </Stack>
              </TableCell>

              <TableCell padding={"checkbox"} sx={{py: 1, px: 1, display: {xs: "none", md: "table-cell"}}}>
                <Input
                  className={"table-input"}
                  value={filters?.caller} disableUnderline={false} placeholder={"Caller"}
                  onChange={e => setFilters(prev => ({...prev, caller: e?.target?.value}))}
                />
              </TableCell>
              <TableCell padding={"checkbox"} sx={{ py: 1, px: 1, minWidth: 120 }}>
                <Autocomplete
                  value={filters.status || null}
                  onChange={(event, newValue) => {
                    setFilters(prev => ({ ...prev, status: newValue }));
                  }}
                  options={["ACTIVE", "FINISHED", "REDIRECTED", "FAILED", "HANDOVER", "HANGUP", "MISSED_CALL"]}
                  clearOnEscape
                  freeSolo={false}
                  className={"table-input"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Status"
                      className={"table-input"}
                      variant="standard"
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: false,
                      }}
                    />
                  )}
                  sx={{ width: '100%' }}
                />
              </TableCell>
              <TableCell padding={"checkbox"} sx={{py: 1, px: 1}}></TableCell>
              <TableCell padding={"checkbox"} sx={{py: 1, px: 1, textWrap: "nowrap", display: {xs: "none", md: "table-cell"} }}></TableCell>
              {type === "VOICE_BOT" ? <TableCell padding={"checkbox"} sx={{py: 1, px: 1}}></TableCell> : null }
            </TableRow>
          </TableHead>
          <TableBody id={"conversation-tbody"}>
            {conversations?.map(item => (
              <ConversationTableRow
                key={item?.id} conversation={item} project={project}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack direction={"row"} sx={{width: "100%"}} justifyContent={"flex-end"}>
        <TablePagination
          component="div"
          count={pagination?.totalElements}
          page={pagination?.page}
          onPageChange={(e, page) => setPagination(prev => ({...prev, page: page}))}
          rowsPerPage={pagination?.size}
          onRowsPerPageChange={(e) => setPagination(prev => ({...prev, page: 0, size: +e.target.value}))}
        />
      </Stack>
    </Stack>
  )
 }